import { useState, useEffect } from 'react'
import { ServiceFactory } from '../../../../../../core/factories/ServiceFactory'
import { PlatformBranding } from '../../../../../../core/models/Workspace'

export const useWorkspaceBranding = () => {
  const [branding, setBranding] = useState<PlatformBranding | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const loadBranding = async () => {
      try {
        setLoading(true)
        setError(null)
        
        const workspaceService = ServiceFactory.getInstance().getWorkspaceService()
        const brandingInfo = workspaceService.getPlatformBranding()
        
        setBranding(brandingInfo)
      } catch (err) {
        console.error('Failed to load workspace branding:', err)
        setError('Failed to load branding information')
      } finally {
        setLoading(false)
      }
    }

    loadBranding()
  }, [])

  return {
    branding,
    loading,
    error
  }
} 